'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var react = require('react');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var withAnalytics = require('../../withAnalytics.js');
var SortableTableHeaderCell = require('../alloy-list-manager/SortableTableHeaderCell.js');
var sortTypes = require('../alloy-list-manager/sortTypes.js');
var rowPositionTypes = require('./rowPositionTypes.js');
var table_module = require('./table.module.scss.js');
var Table_types = require('./Table.types.js');
var utils = require('./utils.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var DEFAULT_KEY_GEN = function (_a) {
    var _b = _a.reactKey, reactKey = _b === void 0 ? '' : _b;
    return reactKey;
};
var Table = function (_a) {
    var className = _a.className, data = _a.data, footerData = _a.footerData, schema = _a.schema, _b = _a.customRenderers, customRenderers = _b === void 0 ? {} : _b, keyGenerator = _a.keyGenerator; _a.analyticsEvents; var showAllNotes = _a.showAllNotes, suppressFooter = _a.suppressFooter, _c = _a.showFooterInTablet, showFooterInTablet = _c === void 0 ? false : _c, rest = tslib.__rest(_a, ["className", "data", "footerData", "schema", "customRenderers", "keyGenerator", "analyticsEvents", "showAllNotes", "suppressFooter", "showFooterInTablet"]);
    var NoteSection = function (_a) {
        var _b;
        var item = _a.item, showBottomBorder = _a.showBottomBorder;
        return (jsxRuntime.jsx("tr", { children: jsxRuntime.jsx("td", tslib.__assign({ "data-testid": "notes-table-cell", colSpan: schema.length, style: {
                    borderBottomWidth: item.isDeleted || item.rowNotesPosition === rowPositionTypes.RowNotesPositions.TOP
                        ? '0px'
                        : '1px'
                }, className: cx__default.default('w-100 p-0', (_b = {},
                    _b[table_module.default['bottom-border']] = showBottomBorder,
                    _b[table_module.default['cell-height-0']] = item.isDeleted,
                    _b)) }, { children: jsxRuntime.jsx("div", tslib.__assign({ className: cx__default.default(table_module.default['collapsable'], item.isDeleted ? table_module.default['collapsed'] : table_module.default['expanded-notes']) }, { children: item.rowNotes })) })) }));
    };
    var getAlignment = function (type) {
        switch (type) {
            case Table_types.DataType.NUMBER:
                return 'end';
            case Table_types.DataType.ALPHANUMERIC:
                return 'start';
            case Table_types.DataType.ICON:
                return 'center';
            default:
                return 'start';
        }
    };
    var getStretchedWidth = function () {
        var val = schema.reduce(function (acc, cur) { return (Table_types.ColumnType.STRETCHED === cur.columnType ? acc + 1 : acc); }, 0);
        return val === 0 ? 1 : val;
    };
    var getColumnStyles = function (col, isHeader) {
        switch (col.columnType) {
            case Table_types.ColumnType.FIXED:
                return { width: col.width };
            case Table_types.ColumnType.HUGGED:
                return isHeader
                    ? { width: 0 }
                    : { display: 'table-cell', whiteSpace: 'nowrap' };
            case Table_types.ColumnType.STRETCHED:
                return { width: "".concat(100 / getStretchedWidth(), "%") };
            default:
                return { width: col.width };
        }
    };
    /**
     * We need to know if there are sortable headers to decide to add a bottom padding
     * to non-sortable headers so that they all look aligned
     */
    var hasTableSortableHeaders = schema.some(function (_a) {
        var isSortable = _a.isSortable;
        return isSortable;
    });
    return (jsxRuntime.jsxs("table", tslib.__assign({ width: "100%", className: cx__default.default("".concat(table_module.default['alloy-table']), className) }, rest, { children: [jsxRuntime.jsx("thead", { children: jsxRuntime.jsx("tr", { children: schema.map(function (col) {
                        var _a;
                        var thProps = {
                            children: col.label || '',
                            className: cx__default.default(table_module.default['d-none-not-important'], 'py-2 text-capitalize', table_module.default['table-head-cell'], table_module.default['bottom-border'], (_a = {},
                                _a[table_module.default['d-lg-table-cell-not-important']] = !col.hideOnDesktop,
                                _a[table_module.default['non-sortable-header']] = !col.isSortable && hasTableSortableHeaders,
                                _a), col.className),
                            'data-testid': 'table-header',
                            key: "header-".concat(col.id),
                            style: tslib.__assign({ padding: col.padding || '0.5rem', verticalAlign: 'bottom', textAlign: (col.dataType
                                    ? getAlignment(col.dataType)
                                    : col.align || 'start') }, getColumnStyles(col, true)),
                            role: col.headerRole || 'columnheader'
                        };
                        var sortableProps = {
                            sortBy: col.sortBy || col.id,
                            sortType: col.sortType || sortTypes.SortTypeTypes.ALPHANUMERIC,
                            footnote: col.footnote,
                            invertArrows: col.invertArrows,
                            onClick: col.onHeaderClick
                        };
                        return col.isSortable ? (jsxRuntime.jsx(SortableTableHeaderCell.default, tslib.__assign({}, thProps, sortableProps))) : (jsxRuntime.jsx("th", tslib.__assign({}, thProps)));
                    }) }) }), jsxRuntime.jsx("tbody", { children: data.map(function (item, rowIndex) {
                    var _a;
                    var notesPos = item.rowNotesPosition || rowPositionTypes.RowNotesPositions.BOTTOM;
                    var showNotes = utils.showRowNotes(item, showAllNotes);
                    return (jsxRuntime.jsxs(react.Fragment, { children: [showNotes && notesPos === rowPositionTypes.RowNotesPositions.TOP && (jsxRuntime.jsx(NoteSection, { item: item })), jsxRuntime.jsx("tr", tslib.__assign({ "data-testid": "table-body-row" }, ((_a = item === null || item === void 0 ? void 0 : item.rowProperties) !== null && _a !== void 0 ? _a : {}), { children: schema.map(function (col) {
                                    var _a, _b;
                                    var _c, _d, _e, _f, _g, _h, _j, _k;
                                    return (react.createElement("td", tslib.__assign({ style: tslib.__assign({ textAlign: (col.dataType
                                                ? getAlignment(col.dataType)
                                                : col.align || 'start'), borderBottomWidth: item.isDeleted ||
                                                (utils.showRowNotes(item, showAllNotes) &&
                                                    item.rowNotesPosition !== rowPositionTypes.RowNotesPositions.TOP)
                                                ? '0px'
                                                : '1px' }, getColumnStyles(col, false)) }, ((_c = col === null || col === void 0 ? void 0 : col.cellProperties) !== null && _c !== void 0 ? _c : {}), ((_e = (_d = item === null || item === void 0 ? void 0 : item.customCellProperties) === null || _d === void 0 ? void 0 : _d[col.id]) !== null && _e !== void 0 ? _e : {}), { className: cx__default.default(utils.getDisplayClass(col), (_a = {},
                                            _a[table_module.default['cell-height-0']] = item.isDeleted,
                                            _a), col.verticalAlign || 'align-top', (_b = {},
                                            _b[table_module.default['bottom-border']] = !utils.showRowNotes(item, showAllNotes) ||
                                                (showNotes && notesPos === rowPositionTypes.RowNotesPositions.TOP),
                                            _b), table_module.default['p-0-not-important'], col.className, (_f = item.customCellClassNames) === null || _f === void 0 ? void 0 : _f[col.id]), key: col.id }),
                                        jsxRuntime.jsx("div", tslib.__assign({ style: {
                                                padding: col.padding ? col.padding : '0.5rem',
                                                /*
                                                /* We only want to set width for this div when it is expressed in pixels
                                                /* not when it is expressed in percentage (%).
                                                /* When expressed on percentage it reduce the lenth of this div.
                                                /¨* Regexp test /px/.test(col.width ?? '') returns true when width is in pixels
                                                */
                                                width: /px/.test((_g = col.width) !== null && _g !== void 0 ? _g : '') ? col.width : '',
                                                minWidth: /px/.test((_h = col.width) !== null && _h !== void 0 ? _h : '') ? col.width : '',
                                                maxWidth: /px/.test((_j = col.width) !== null && _j !== void 0 ? _j : '') ? col.width : '',
                                                maxHeight: col.maxHeight ? col.maxHeight : ''
                                            }, className: cx__default.default(col.contentClassName, table_module.default['collapsable'], item.isDeleted
                                                ? table_module.default['collapsed']
                                                : table_module.default['expanded']) }, { children: col.id in customRenderers
                                                ? customRenderers[col.id](item, col, false, rowIndex)
                                                : (_k = item[col.id]) !== null && _k !== void 0 ? _k : '' }))));
                                }) })), showNotes && notesPos === rowPositionTypes.RowNotesPositions.BOTTOM && (jsxRuntime.jsx(NoteSection, { item: item, showBottomBorder: true }))] }, keyGenerator(item)));
                }) }), utils.hasFooter(schema) && !suppressFooter && (jsxRuntime.jsx("tfoot", { children: jsxRuntime.jsx("tr", tslib.__assign({ className: cx__default.default('d-none border-bottom-0', {
                        'd-md-table-row': showFooterInTablet,
                        'd-lg-table-row': !showFooterInTablet
                    }) }, { children: schema.map(function (col) {
                        var _a;
                        return (jsxRuntime.jsx("td", tslib.__assign({ style: tslib.__assign({ padding: col.padding || '0px', textAlign: (col.footerAlign ||
                                    'left') }, getColumnStyles(col, false)) }, { children: col.footerId && col.footerId in customRenderers
                                ? customRenderers[col.footerId](footerData, col, true)
                                : (_a = (footerData && footerData[col.footerId])) !== null && _a !== void 0 ? _a : '' }), "footer-".concat(col.id)));
                    }) })) }))] })));
};
Table.defaultProps = {
    customRenderers: {},
    keyGenerator: DEFAULT_KEY_GEN
};
var exportComponent = withAnalytics.withAnalytics(Table);
exportComponent.displayName = Table.name;
exportComponent.defaultProps = Table.defaultProps;
var exportComponent$1 = exportComponent;

exports.Table = Table;
exports.default = exportComponent$1;
//# sourceMappingURL=Table.js.map
